import React from "react";
import { OrderedCellRendererProps } from "../Grid/types";
import {
  NewReqActionCellWrapper,
  TestOrderPrimary,
  TestOrderSecondary,
  TestOrderStack,
} from "./NewRequisition.styles";
import {
  getTestOrderDisplay,
  TEST_TYPE_LABELS,
} from "../../utils/testOrderDisplay";
import { DRAFT_STATUS } from "./types";

export const NewReqTestsOrderedCell: React.FC<OrderedCellRendererProps> = ({
  data,
}) => {
  if (data.is_cfc_order) {
    return (
      <NewReqActionCellWrapper>
        <TestOrderStack>
          <TestOrderPrimary>{TEST_TYPE_LABELS.UNITY_CONFIRM}</TestOrderPrimary>
        </TestOrderStack>
      </NewReqActionCellWrapper>
    );
  }

  const { primary, secondary } = getTestOrderDisplay({
    isCarrierScreenOrder: data.is_carrier_screen_order,
    isAneuploidyOrder: data.is_aneuploidy_order,
    expandedCarrierPanel: data.expanded_carrier_panel,
    isFragileX: data.is_fragile_x,
    isAcogPlus: data.is_acog_plus,
    isAneuploidyOptOutFetalSex: data.is_aneuploidy_opt_out_fetal_sex,
    isAneuploidyIncludeRhd: data.is_aneuploidy_include_rhd,
    isFetalAntigen: data.is_fetal_antigen,
  });

  const isRedrawSubmitted = data.draft_status === DRAFT_STATUS.SUBMITTED_REDRAW;
  let displayPrimary = primary;
  if (isRedrawSubmitted) {
    displayPrimary = primary ? `Redraw - ${primary}` : "Redraw";
  }

  return (
    <NewReqActionCellWrapper>
      <TestOrderStack>
        <TestOrderPrimary>{displayPrimary}</TestOrderPrimary>
        {secondary && <TestOrderSecondary>{secondary}</TestOrderSecondary>}
      </TestOrderStack>
    </NewReqActionCellWrapper>
  );
};
